export default {
  route: {
    dashboard: 'Dashboard',
    warningManagement: 'Warning Management',
    overview: 'Overview',
    systemDashboard: 'System Dashboard',
    todayOverview: 'Today Overview',
    mineOverview: 'Mine Overview',
    shareOverview: 'Share Overview',
    overviewDetail: 'Overview Detail',
    bookmarkList: 'Bookmark List',
    analysis: 'Analysis',
    overallAnalysis: 'Overall Analysis',
    eventAnalysis: 'Event Analysis',
    ltVAnalysis: 'LTV Analysis',
    pageAnalysis: 'Page Analysis',
    pageDetail: 'Page Detail',
    userBehavior: 'Behavior Trace',
    channelAnalysis: 'Channel Analysis',
    funnelAnalysis: 'Funnel Analysis',
    retainedAnalysis: 'Retained Analysis',
    intervalAnalysis: 'Interval Analysis',
    userDetail: 'User Detail',
    userPath: 'User Path',
    distributionAnalysis: 'Distribution Analysis',
    sessionAnalysis: 'Session Analysis',
    landingAnalysis: 'Landing Analysis',
    attributionAnalysis: 'Attribution Analysis',
    customIndicator: 'Custom Indicator',
    operatingIndicator: 'Operating Indicator',
    group: 'Group',
    userGroup: 'User Group',
    userList: 'User List',
    analyseUserList: 'User Detail',
    channel: 'Channel',
    channelActivity: 'Channel Activity',
    channelLink: 'Channel Link',
    channelPromote: 'Channel Promote (old)',
    channelRule: 'Channel Rule',
    shortChainDetail: 'Short Chain Detail',
    buriedPoint: 'Buried Point',
    aliyunLogQuery: 'Log Query',
    ckLogQuery: 'Log Query',
    eventGroup: 'Event Group',
    eventRecycle: 'Event Recycle',
    customEvent: 'Custom Event',
    newCustomEvent: 'New Custom Event',
    editCustomEvent: 'Edit Custom Event',
    customEventDetail: 'Custom Event Detail',
    virtualEvent: 'Virtual Event',
    metaEvent: 'Meta Event',
    metadata: 'Meta Data',
    setting: 'Setting',
    projectList: 'Project List',
    appList: 'Application List',
    personList: 'Person List',
    roleManagement: 'Role Management',
    tenantInformation: 'Tenant Information',
    developConfiguration: 'Develop Configuration',
    accountSetting: 'Account Setting',
    system: 'System',
    tenantManagement: 'Tenant Management',
    accessMenu: 'Access Menu',
    userManagement: 'User Management',
    projectManagement: 'Project Management',
    appManagement: 'Application Management',
    channelManagement: 'Channel Management',
    appApply: 'Application Apply',
    mhInstanceConfigSource: 'Syn Data Source',
    mhInstanceConfigTask: 'Syn Task'
  },
  login: {
    selectTenant: 'Select tenant',
    accountSettings: 'Account settings',
    basicInformation: 'Basic information',
    name: 'Name',
    address: 'Address',
    logout: 'Log out',
    scanLogin: 'Scan code login',
    scanSuccess: 'Scan code successfully',
    welcomeLogin: 'Welcome to login the Tracking System',
    expired: 'The QR code has expired, please',
    refresh: 'Refresh',
    login: 'Login',
    openMiniProgram: 'Open the Tracking applet, scan to log in'
  },
  navbar: {
    changeTenant: 'Change Tenant',
    accountSetting: 'Account Setting',
    logOut: 'Log Out',
    welcome: 'Welcome, '
  },
  public: {
    default: 'default',
    choice: 'more',
    copy: 'Copy',
    test: 'Test',
    queryTime: 'Query time',
    online: 'online time',
    pleaseChoose: 'Please select',
    timeInterval: 'Please select time interval',
    time: 'Time',
    loading: 'Loading...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    detail: 'Detail',
    delete: 'Delete',
    new: 'Add',
    assign: 'Assign',
    share: 'Share',
    update: 'Update',
    edit: 'Edit',
    editMhId: 'MH Identification',
    behavior: 'Behavior Trace',
    noData: 'No Data',
    confirmDel: 'Confirm deletion?',
    prompt: 'Prompt',
    successDel: 'Successfully deleted',
    successLink: 'Data source link successful.',
    failDel: 'Delete failed',
    successAdd: 'successfully Added',
    successSetting: 'Set successfully',
    startDate: 'Start date',
    endDate: 'End date',
    startDateTime: 'Start Date time',
    endDateTime: 'End Date time',
    to: 'To',
    today: 'Today',
    lastWeek: 'Last week',
    lastMonth: 'Last month',
    lastThreeMonth: 'Last 3 months',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    type: 'Type',
    yes: 'YES',
    no: 'NO',
    query: 'Query',
    export: 'Export',
    exportCsv: 'Export to csv file',
    clearFilter: 'Clear filters',
    save: 'Save',
    callback: 'return',
    second: 'Second',
    minute: 'Minute',
    onMonday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    hour: 'Hour',
    connector1: 'Not empty',
    connector2: 'Empty',
    connector3: 'Not equal',
    connector4: 'Equal',
    connector5: 'more than',
    connector6: 'Less than',
    connector7: 'Left contains',
    connector8: 'Worthy',
    connector9: 'Worthless',
    connector10: 'Interval',
    connector11: 'greater or equal to',
    connector12: 'Less than or equal to',
    connector13: 'Is true',
    connector14: 'Is false',
    connector15: 'Contain',
    connector16: 'Right contains',
    connector17: 'Does not contain',
    by: 'by',
    is: 'is',
    of: 'of',
    remark: 'Remark',
    import: 'Import',
    disable: 'Disable',
    enable: 'Enable',
    normal: 'Normal',
    selectDate: 'Please select date',
    add: 'Add',
    string: 'String',
    number: 'Number',
    view: 'View',
    batchImport: 'Batch import',
    uploadFile: 'Upload file',
    templateDownload: 'Template download',
    file: 'File',
    template: 'Template',
    allTimes: 'Total times',
    distribute: 'Distribute',
    stayTime: 'Stay time',
    stayTimeAll: 'Total length of stay',
    sum: 'Sum',
    average: 'Average',
    max: 'Max',
    min: 'Min',
    times: 'Times',
    day: 'Day',
    timesNumber: 'Times',
    dayNumber: 'Days',
    visitTimes: 'Number of visits',
    hourNumber: 'Hours',
    deduplication: 'Deduplication',
    pcs: 'Pcs',
    peopleAvg: 'Per capita',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    recover: 'recover',
    successRecover: 'success recover',
    failRecover: 'fail recover',
    successReclaim: 'success reclaim',
    failReclaim: 'success reclaim',
    platform: 'tenant',
    systemUser: 'user',
    chineseEnglish: 'Language',
    lastPage: 'last',
    nextPage: 'next',
    establish: 'Create',
    accountLogin: 'Account login',
    updateTheCurrentTag: 'Updates the current label',
    addToOverview: 'Add to Overview',
    saveAsANewLabel: 'Save as a new label',
    saveAsLabel: 'Save as a label',
    myBookmark: 'My bookmarks',
    OverviewTip:
      'My Overview is only supported by myself, can be shared with others to view, and will generate a bookmark of the current query criteria to save in the bookmark list',
    myBookmarkTip: 'My bookmarks can be viewed on the Bookmarks page and can be added to My Bookmarks',
    scanCodeLogin: 'Scan to log in',
    EnterTenantName: 'Please enter a tenant name',
    domainNameWhitelin: 'Domain name whitelist',
    archived: 'filed',
    unArchived: 'unfiled',
    filed: 'place on file',
    Filed: 'Place on file'
  },
  message: {
    m1: 'The bookmark is already in use at Glance and cannot be deleted',
    m2: 'Cancelled',
    m3: 'No data found',
    m4: 'Please try to adjust the time period or filter criteria',
    m5: 'Please fill in the information completely!',
    m6: 'Please select conditions',
    m7: 'Please select the connector',
    m8: 'Please select a value',
    m9: 'No group selected',
    m10: 'No indicator selected',
    m11: 'Please select attributes',
    m12: 'No event selected',
    m13: 'Please enter group name',
    m14: 'please input the value',
    m15: 'Please enter an integer',
    m16: 'Enter funnel name',
    m17: 'No period selected',
    m18: 'No funnel step event selected',
    m19: 'The funnel step must have two or more steps',
    m20: 'Cannot create a new group if no project has been selected!',
    m21: 'Do you want to delete the event?',
    m22: 'delete or not ?',
    m23: 'Deleting a funnel will delete the bookmarks and overview components related to the funnel. Do you want to delete the funnel?',
    m24: 'Is it possible to apply online?',
    m25: 'Is it possible to apply online?',
    m26: 'Can I cancel the online application?',
    m27: 'Do you want to delete the data?',
    m28: 'Do you want to delete the link?',
    m29: 'Do you want to delete the channel?',
    m30: 'This operation will permanently delete the attribute, do you want to continue?',
    m31: 'Do you want to delete custom events?',
    m32: 'Is this attribute deleted?',
    m33: 'Are you sure you want to delete this event group? Whether to continue?',
    m34: 'Are you sure you want to delete this menu? Whether to continue?',
    m35: 'Are you sure you want to delete this role? Whether to continue?',
    m36: 'No item selected yet, cannot add event!',
    m37: 'added successfully',
    m38: 'Edit successfully',
    m39: 'No data analysis yet',
    m40: 'Please check the interval specification carefully: the left interval value cannot be greater than the right interval value!',
    m41: 'Please complete the setting group information!',
    m42: 'The number of days can not be greater than 7 days',
    m43: 'Successfully created funnel!',
    m44: 'Edit funnel successfully!',
    m45: 'The number of days is greater than 3 days, and you can only choose by day',
    m46: 'Successfully specified UV statistics fields!',
    m47: 'Successful application',
    m48: 'Successfully passed the application',
    m49: 'No project has been selected yet, channel cannot be added!',
    m50: 'Channel successfully added',
    m51: 'Channel modified successfully',
    m52: 'Have not selected the app',
    m53: 'Only supports single file upload',
    m54: 'Channel file imported successfully',
    m55: 'Import failed! !',
    m56: 'No project has been selected, no channel rules can be added!',
    m57: 'Successfully modified!',
    m58: 'No item has been selected, no link can be added!',
    m59: 'Please select the trigger time range',
    m60: 'Please select the events to be grouped!',
    m61: 'Group success',
    m62: 'No project has been selected yet, cannot create a new event!',
    m63: 'Please select the event to be deleted!',
    m64: 'No application selected',
    m65: 'Cannot add an overview if no item has been selected!',
    m66: 'No item selected yet, cannot add attributes',
    m67: 'Authorization succeeded',
    m68: 'The information has been modified successfully!',
    m69: 'Please fill in the information correctly!',
    m70: 'Successfully appointed the project leader!',
    m71: 'The current project data is in use, please select another project!',
    m72: 'Two password entries are inconsistent',
    m73: 'Password reset complete',
    m74: 'No project has been selected yet, short chain cannot be added!',
    m75: 'The short chain file was imported successfully',
    m76: 'Password reset successfully',
    m77: 'Cancel success!',
    m78: 'update completed',
    m79: 'Please select event attributes',
    m80: 'No starting behavior selected',
    m81: 'No follow-up action selected',
    m82: 'Please select an event',
    m83: 'Please select a group',
    m84: 'Choose at least one event to participate in the analysis',
    m85: 'No landing page selected',
    m86: 'Please select an Indicator',
    m87: 'Please enter an integer greater than 0',
    m88: 'Please enter content',
    m89: 'Can not be empty',
    m90: 'Please enter the alert name',
    m91: 'Please select a warning event',
    m92: 'Please select application',
    m93: 'No profile selected',
    m94: 'Please fill in the component name',
    m95: 'Please enter the event name, no more than 48 characters',
    m96: 'No calculation result selected',
    m97: 'Please enter the indicator name',
    m98: 'Not entered',
    m99: 'Please select the application',
    m100: 'No article title entered',
    m101: 'No link entered',
    m102: 'Short chain with monitoring is not entered',
    m103: 'No funnel selected for analysis',
    m104: 'Please select the tenant of the application',
    m105: 'Please select the project',
    m106: 'Please enter the application name',
    m107: 'Please select the application platform',
    m108: 'Please select application status',
    m109: 'No application selected',
    m110: 'No query time range selected',
    m111: 'No major channel entered',
    m112: 'No sub-channel entered',
    m113: 'Channel ID not entered',
    m114: 'Channel name not entered',
    m115: 'No link delivery address entered',
    m116: 'The link landing page address is not entered',
    m117: 'Channel location is not entered',
    m118: 'Please enter the rule prefix match',
    m119: 'Please enter the rule replacement content',
    m120: 'Please enter the link name, no more than 16 characters',
    m121: 'Please enter the promotion address, no more than 120 characters',
    m122: 'Please enter the campaign source, no more than 30 characters',
    m123: 'Please enter the campaign medium, no more than 30 characters',
    m124: 'Please enter the campaign content, no more than 200 characters',
    m125: 'Please enter the campaign name, no more than 16 characters',
    m126: 'Please enter the advertising keyword, no more than 16 characters',
    m127: 'Please enter the channel name, no more than 16 characters',
    m128: 'Please enter the logo, no more than 16 characters',
    m129: 'Please select the application platform to which the event belongs',
    m130: 'Event name not entered',
    m131: 'Please select the application platform to which the event belongs',
    m132: 'Please enter a name',
    m133: 'Please select sharing type',
    m134: 'Group name cannot be empty',
    m135: 'Please enter the attribute ID',
    m136: 'Attribute name',
    m137: 'Please select data type',
    m138: 'Please select data attributes',
    m139: 'Event ID cannot be empty',
    m140: 'Event name cannot be empty',
    m141: 'Menu name cannot be empty',
    m142: 'Menu code cannot be empty',
    m143: 'Menu path cannot be empty',
    m144: 'Path format only supports English, "_", "/" combination',
    m145: 'Please enter the project name',
    m146: 'Please enter item type',
    m147: 'Please select project status',
    m148: 'No role name entered',
    m149: 'Role code cannot be empty',
    m150: 'The character encoding format only supports English, numbers, and underscores',
    m151: 'Name cannot be empty',
    m152: 'Email address cannot be empty',
    m153: 'Please input the correct email address',
    m154: 'Please enter the correct phone number',
    m155: 'Please enter the organization key',
    m156: 'Please enter organization key',
    m157: 'Old password cannot be empty',
    m158: 'New password cannot be empty',
    m159: 'Please enter the new password again',
    m160: 'Username can not be empty',
    m161: "User's password is not entered",
    m162: 'The password format only supports English, numbers, and underscores',
    m163: 'Password length can only be between 6-30',
    m164: 'Please enter an organization name',
    m165: 'Please enter the organization address',
    m166: 'No user type selected',
    m167: 'Owning application cannot be empty',
    m168: 'Event name cannot be empty',
    m169: 'Only number type can be entered',
    m170: 'Please input',
    m171: 'Please enter key words',
    m172: 'Please select application',
    m173: 'All group',
    m174: 'Please add attribute',
    m175: 'Files can only be uploaded and downloaded in template format',
    m176: 'Please download the latest template',
    m177: "Please enter the subscriber's mailbox number, separate multiple mailbox numbers with ','",
    m178: 'Please select an organization',
    m179: 'Please choose a role',
    m180: 'Please Select the target transform event',
    m181: 'Please Select the event to be attributed',
    m182: 'Please enter the password first',
    m183: 'Congratulations, the password has been copied successfully!',
    m184: 'Deleting session will delete the signature and overview component associated with that session?',
    m185: 'Did not choose the Session',
    m186: 'Congratulations, the creation is successful!',
    m187: 'Congratulations, the update is successful!',
    mInput: 'Please enter the...',
    user: 'Please enter',
    textguid: 'Please enter ID',
    mSel: 'Please select a...',
    m188: 'The synchronization data source already has a synchronization task and cannot be deleted.',
    m199: 'Moved to trash successfully',
    m200: 'Please select the event that needs to be recovered',
    m201: 'Please select the event that needs to be moved to the trash',
    m202: 'Do you want to move restore custom events',
    m203: 'Do you want to move to trash',
    m204: 'Do you want to delete user group',
    m205: 'Do you want to online this app?',
    m206: 'success online app',
    m207: 'The synchronization data source already has a synchronization task and cannot be deleted.',
    m208: 'File path cannot be empty',
    m209: 'Forward related event: generally, it is a tie event between "to be attributed event" and "target transformation event", such as commodity details, adding to shopping cart and other events related to commodity exposure;',
    m210: 'In the attribution analysis, the auxiliary exposure point participates in the calculation to improve the calculation accuracy of the attribution model',
    m211: 'please select application online time',
    m212: 'Please select the behavior',
    m213: 'Please configure the application first',
    m214: 'Please select the applets to unbind',
    m215: 'Please select which attribute to rank after',
    m216: 'Please select the channel to be attributed',
    m257: 'Please check direct conversion to participate in attribution calculation',
    m258: 'At most 10 revenue behaviors can be added',
    m259: 'You can add up to 10 filter criteria',
    m260: 'Only 1 filter criteria can be added',
    m261: 'Please enter the data source name',
    m262: 'Please enter user name',
    m263: 'Please enter the data source address',
    m264: 'Please select type',
    m265: 'Event attributes of the same event cannot be repeated select',
    m266: 'Duplicate events involved in analysis',
    m267: 'Split weekly data based on the start time and end time and collect statistics within the start time and end time range',
    m268: 'Data is split by month based on the start time and end time. Statistics are collected within the start time and end time range',
    m269: 'Please enter a task name',
    m270: 'Please enter a data source',
    m271: 'Please enter the target table',
    m272: 'Please select a data type',
    m273: 'Please select a sync frequency',
    m274: 'The name cannot be empty',
    m275: 'Events cannot be empty',
    m276: 'The cut rule time value cannot be empty',
    m277: 'The cut rule time type cannot be empty',
    m278: 'Do you want to delete a virtual event?',
    m279: 'Are you sure you want to delete this page property? Do you want to continue?',
    m280: 'Are you sure you want to retire this tenant? Do you want to continue?',
    m281: 'Are you sure you want to delete this data source? Do you want to continue?',
    m282: 'Are you sure you want to delete the task? Do you want to continue?',
    m283: 'The indicator definition is not legal, please modify it',
    m284: 'Domain names should be separated by ","',
    m285: 'Please enter sessionInterValue',
    m286: 'Minimum value is 1',
    m287: 'The unit is minute and the maximum value  is 525600',
    m288: 'The unit is hour and the maximum value is 8760',
    m299: 'Detecting behavioral data collected within 30 days of the application, is it archived? (No further data are collected after archiving and the archiving operation is irreversible)',
    m300: 'Is archiving performed? (Data are no longer collected after archiving and the archiving operation is irreversible)',
    m301: 'success'
  },
  tooltip: {
    t1: 'The prompt option is the attribute keywords of the last seven days<br> (maximum display 30), not all keywords. <br>You can directly enter keywords and press Enter to complete.',
    t2: 'If there is no click event, please go to <br>"Buried Points-Custom Event" to <br> synchronize!',
    t3: 'The prompt option is the attribute keyword of the day, and <br>the keyword of the day. <br>You can directly enter keywords and press Enter to complete.',
    t4: 'Decline',
    t5: 'Rise',
    t6: 'Compared',
    t7: 'Generally, it is the income related events <br>such as the payment and purchase order of the product.',
    t8: 'Generally for the click of advertising, <br>operation bit click and other operation-related events.',
    t9: 'If a "target transformation event" does not have any related <br>"to be attributed event" before transformation, then the <br>"target transformation event" is considered as direct transformation.',
    t10: 'The average of the users who visited the Web page the first day, <br>and the Web page the next day, and who did not appear 180 days <br>before the selected start time (new users).',
    t11: 'Jump out means that the user chooses to leave <br /> after only one interaction in one visit. Calculation formula: <br /> the percentage of the session that is the "only page" <br /> in the session in all sessions started by the page. <br /> The higher the bounce rate, the lower the attraction <br /> of the website to visitors. When the bounce rate reaches <br /> a certain level, it means that the website needs <br /> to be optimized or updated',
    t12: 'It refers to the percentage of the "last page" <br /> of the page in the total page views. The comprehensive <br /> viewing volume of the home page is 1000, and the number <br /> of times to leave the site from this page is 40, so the exit rate of the home <br /> page is 4%. The high bounce rate means that many new users come and <br /> leave after seeing a page. The low dropout rate means that old  <br />and new users click many pages before leaving',
    t13: 'Favorite items, which will promote items in the top drop-down list items sorted',
    t14: 'It refers to the effective time range after the calculation starts. If it exceeds the effective time range, the calculation ends',
    t15: 'Page name',
    t16: 'The page is complete with reference addresses, and one page supports multiple access with reference addresses',
    t17: 'Page access path (without parameters), one path corresponds to one page',
    t18: 'Satisfying the first contact accounts for 100% conversion',
    t19: 'Satisfying the last contact accounts for 100% conversion',
    t20: 'The contacts that meet the conditions are equally distributed with conversion contributions',
    t21: 'According to the set contribution ratio, calculate the contribution ratio of each contact, 40% for the first time, 20% for the middle, and 40% for the end',
    t22: 'According to the set contribution ratio, calculate the contribution ratio of each contact, 40% for the first time, 20% for the middle, and 40% for the end',
    t23: 'First contact attribution: when multiple "to-be-attributed events" contribute to the same "target conversion event", the credit of the first "to-be-attributed event" is 100%.<br/>Last contact attribution: when multiple "to-be-attributed events" contribute to the same "target conversion event", the credit of the last "to-be-attributed event" is 100%<br/>Linear attribution: when multiple "to be attributed events" make contributions to the same "target conversion event", it is considered that each "to be attributed event" is equally distributed with this contribution<br/>Location attribution: when multiple "to be attributed events" contribute to the same "target conversion event", the first and the last "to be attributed events" account for 40% of the credit respectively, and the rest "to be attributed events" share the remaining 20% of the credit equally<br/>Time decay attribution: when multiple "to be attributed events" contribute to the same "target conversion event", the closer the "target conversion event", the greater the contribution.',
    t24: 'Refers to users who have not appeared in the past six months within the selected time range',
    t25: 'Number of visitors with unique identity of new users. New user definition: refers to users that have not appeared in the past half a year within the selected time range',
    t26: 'The total number of all sessions, that is, when analyzing the specific events in the session, the number of events in the session can be calculated',
    t27: 'Calculate the number of simultaneous sessions at this point in time. We think that a session is a continuous period of time, and the number of concurrent sessions is the number of simultaneous concurrent sessions',
    t28: 'Calculation formula: total number of Seesion/number of unique visitors',
    t29: 'stay time'
  },
  overview: {
    applicationKey: 'Application',
    initialbehavior: 'Initialbehavior',
    today: 'Today',
    yesterday: 'Yesterday',
    recentSevenDays: 'Last 7 days',
    recentThirtyDays: 'Last 30 days',
    baseIndicator: 'Basic Indicators',
    pvuvTrend: 'PV&UV Trend',
    channelTable: 'Channel PV/UV/Visits per capita',
    pageTable: 'Page PV/UV/Visits per capita',
    eventTable: 'Event Click',
    sceneTable: 'Scene PV/UV/Visits per capita',
    channelName: 'Channel name',
    pageName: 'Page name',
    eventName: 'Event name',
    scene: 'scene',
    visitor: 'Visits per capita',
    StandingTime: 'Per capita stay time',
    operation: 'Operation',
    trendDetail: 'Trend details',
    clickNumber: 'The number of clicks',
    clickPeople: 'Clickers ',
    chainRatio: 'Chain ratio',
    chainRatioMean: 'Means compared to yesterday',
    yoy: 'YoY',
    yoyMean: 'Refers to the same day as last week',
    pv: 'Total PV',
    uv: 'Total UV',
    oldUser: 'Cumulative number of old users',
    newUser: 'Number of new users',
    avgUser: 'Visits per capita',
    avgTime: 'Per capita stay time',
    deviceId: 'Device ID number',
    mineOverview: 'My overview',
    shareOverview: 'Share overview',
    overview: 'Overview',
    overviewName: 'Overview name',
    createTime: 'Creation time',
    newOverview: 'New overview',
    creator: 'Creator',
    shareOverviewTitle: 'Share overview',
    shareType: 'Share type',
    userName: 'Username',
    name: 'Name',
    specifyMember: 'Specified member visible',
    allMember: 'All members under the project visible',
    analysisType: 'Select analysis type',
    overallDesc: 'Analyze overall user behavior',
    eventDesc: 'Multi-dimensional analysis of user behavior through conditional filtering, grouping and aggregation capabilities',
    pageDesc: "Analyze page_url/page_name/current_path's PV, UV, average stay time, bounce rate, IP number and other indicators",
    funnelDesc: 'Analyze the conversion and loss of each step in a multi-step process',
    retainedDesc: 'Analyze user participation and activity',
    customDesc: 'Four arithmetic operations between basic indicators can flexibly define unique indicators that meet business scenarios',
    landingDesc: 'Monitoring of various sources of landing pages',
    distributionDesc: 'User distribution of different indicators of the event',
    attributionDesc:
      'Monitor the transformation contribution of key events such as advertising space and promotion space under the product to the target event',
    sessionDesc: "Provide insight into the user's interactions with this set of behaviors",
    channelDesc: 'Index comparison of access channels is carried out to clearly identify the advantages and disadvantages of channels',
    intervalDesc:
      'The time interval between two events in the user behavior sequence is calculated to obtain the transformation time distribution of the business transformation link',
    fromBookmark: 'New From Bookmark',
    newComponent: 'New Component',
    noComponent: 'Unadded component',
    noBookmark: 'No bookmarks',
    firstSaveBookmark: 'Save the analysis model as a bookmark first',
    bookmark: 'Bookmark',
    whichOverview: 'Belonging overview',
    bookmarkName: 'Bookmark name',
    unknown: 'Unknown',
    useOverviewNumber: 'Number of overviews used',
    isDynamicShow: 'Dynamic or not',
    whichApplication: 'Application',
    newUserQuestion: 'Refers to users within the selected time range <br/>that have not appeared in the past six months',
    oldUserQuestion: 'Refers to users that have appeared in <br/>the past six months within the selected time range',
    deviceIdQuestion:
      'The device ID is automatically generated by the Tracking SDK, ' +
      '<br/>which is an anonymous ID. If the product may not have a user identity, ' +
      '<br/>choose the device ID as the user ID',
    chooseABookmark: 'Select the bookmark',
    modifyOverviewName: 'Modify the overview name'
  },
  analysis: {
    querying: 'querying...',
    queue: 'The query is in the queue, waiting, and currently ranked',
    ltvDay: 'ltv day',
    LTVDay: 'LTV day',
    initPerson: 'Initial number',
    indicator: 'Indicator',
    revenuebehavior: 'Revenuebehavior',
    group: 'Group',
    filterCondition: 'Filter',
    relation: 'Set forward associated events',
    addRelation: 'Add forward associated events',
    byDay: 'By day',
    byHour: 'By hour',
    byWeek: 'By week',
    byMonth: 'By month',
    trendChart: 'Trend chart',
    summaryChart: 'Summary chart',
    tableDiagram: 'Table diagram',
    numericalGraph: 'Numerical graph',
    comparisonChart: 'Comparison chart',
    boxChart: 'Box figure',
    total: 'Total',
    average: 'Average',
    display: 'Display',
    saveToOverview: 'Save to overview',
    chartType: 'Chart type',
    event: 'Event',
    condition: 'Condition',
    connector: 'Connector',
    selectFunnel: 'Select Funnel',
    funnel: 'Funnel',
    pleaseFunnel: 'Please select funnel',
    windowPeriod: 'Window period',
    funnelName: 'Funnel name',
    funnelWindow: 'Funnel window',
    attributionWindow: 'Attribution window',
    funnelStep: 'Funnel Step',
    step: 'Step',
    addStep: 'Add step',
    triggerCondition: 'Trigger condition',
    newFunnel: 'New funnel',
    initialBehavior: 'Initial behavior',
    followBehavior: 'Follow-up behavior',
    behavior: 'Behavior',
    value: 'Value',
    eventAttributes: 'Event attributes',
    joinEvent: 'Events involved in analysis',
    setSession: 'Set Session interval',
    beginEvent: 'Begin event',
    endEvent: 'End event',
    userFor: 'User conduct',
    landingPage: 'Landing page',
    conversionGoal: 'Conversion goal',
    newIndicator: 'New indicator',
    editIndicator: 'Edit indicator',
    definedIndicator: 'Define indicators',
    addIndicator: 'New indicator',
    cancelCompare: 'Cancel comparison',
    editCustom: 'Edit custom analysis',
    addCustom: 'Add custom analysis',
    indicatorName: 'Indicator name',
    result: 'Calculation results',
    origin: 'Raw data',
    fixedTwo: 'Keep two decimal places',
    keepInterger: 'Keep integer',
    multipliedBy: 'Multiplied by 100%',
    noData: 'No matching data',
    overview: 'Overview',
    integer: 'Integer',
    metaEvent: 'Meta event',
    clickEvent: 'Click event',
    componentName: 'Component name',
    belongOverview: 'Belong overview',
    addOverview: 'New overview analysis',
    editOverview: 'Edit overview analysis',
    addEvent: 'New event analysis',
    editLtv: 'edit LTV analysis',
    addditLtv: 'Add LTV analysis',
    editEvent: 'Edit event analysis',
    addPage: 'New page analysis',
    editPage: 'Edit page analysis',
    addChannel: 'New channel analysis',
    editChannel: 'Edit channel analysis',
    addSession: 'New session analysis',
    editSession: 'Edit session analysis',
    addFunnel: 'New funnel analysis',
    editFunnel: 'Edit funnel analysis',
    addRetained: 'New retained analysis',
    editRetained: 'Edit retained analysis',
    addIntervalAnalyse: 'New interval analysis',
    editIntervalAnalyse: 'Edit interval analysis',
    addLanding: 'New landing analysis',
    editLanding: 'Edit landing analysis',
    addDistribute: 'New distribution analysis',
    editDistribute: 'Edit distribution analysis',
    addMember: 'New member',
    editMember: 'Edit member',
    channelSource: 'Channel source',
    pageview: 'Pageview',
    vistors: 'Visitors',
    pageviewPV: 'Pageview',
    visitUV: 'Visitors',
    transform: 'Goal conversion',
    historyTrend: 'Detail',
    page: 'Page',
    bounceRate: 'Bounce rate',
    exitRate: 'Exit Rate',
    ipNumber: 'IP',
    pvNumber: 'PV(Views)',
    uvNumber: 'UV(Visitors)',
    pv: 'PV',
    uv: 'UV',
    averageTime: 'Per capita length of stay',
    granularity: 'Granularity',
    viewUserDetail: 'User detail',
    userDetail: 'User detail',
    withinDay: 'Within a day',
    withinWeek: 'Within a week',
    withinMonth: 'Within a month',
    howGroup: 'Setting group',
    interval: 'Interval',
    addInterval: 'Increase interval',
    dayRemain: 'Day retention',
    weekRemain: 'Week retention',
    monthRemain: 'Month retention',
    targetEvent: 'Target transformation event',
    attributionEvent: 'Pending attribution event',
    analysisModel: 'Analysis model',
    firstAttribution: 'First contact attribution',
    lastAttribution: 'Attribution of last contact',
    linearAttribution: 'Attribution of Linear',
    locationAttribution: 'Attribution of location',
    timeAttribution: 'Attribution of time decay',
    directAttribution: 'Direct transformation participates in attribution calculation',
    deviceID: 'Device ID',
    sessionsInteger: 'Session number(Session)',
    avgDeep: 'Average page visit depth',
    groupBy: 'grouped as',
    all: 'Total',
    avgUseTime: 'Average usage time(s)',
    overall: 'Overall',
    totalTimes: 'Total times',
    userNumber: 'User number',
    eventOverview: 'Event overview',
    eventOverviewAnalysis: 'Event overview analysis',
    pageAddr: 'Page address',
    pageName: 'Page name',
    pagePath: 'Page path',
    totalRate: 'Total conversion rate',
    conversionFunnel: 'Conversion funnel',
    fiveMinutes: 'Five minutes',
    oneHour: 'One hour',
    twentyfourHour: 'twenty four hours',
    sevenDays: 'Seven days',
    fourteenDays: 'Fourteen days',
    thirtyDays: 'Thirty days',
    sixtyDays: 'Sixty days',
    defaultAttr: 'Default attributes',
    eventAttr: 'Event attributes',
    pageAttr: 'Page attributes',
    entire: 'Overall',
    overallConversion: 'Overall conversion',
    displayGroup: 'Display group',
    displayIndicator: 'Display indicator',
    people: 'people',
    totalPeople: 'Total',
    date: 'Date',
    sessionsNumber: 'Sessions number',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    sessionPv: 'Of the total of the Session',
    sessionUv: 'The number of sessions concurrent',
    sessionAvg: 'Per capita Session',
    sessionRate: 'Bounce rate',
    sessionTime: 'The stay time(s)',
    transformationEvent: 'Transformation Event',
    webChannel: 'Channel',
    name: 'Name',
    userScale: 'User Scale',
    userQuality: 'User Quality',
    userTarget: 'New user target transformation events',
    channelPv: 'Channel pv',
    channelUv: 'Channel uv',
    channelNewPv: 'Pv of new user',
    channelNewUv: 'Uv of new user',
    newRate: 'Retained of new user',
    middleInterval: 'Median interval',
    maxInterval: 'Max interval',
    minInterval: 'Min interval',
    q1Interval: 'q1 Interval',
    q3Interval: 'q3 Interval',
    avgInterval: 'Avg interval',
    attributionChannel: 'Pending attribution channel',
    contact: 'event',
    channel: 'channel',
    clickScale: 'Click scale',
    totalClick: 'Total hits',
    clickEffective: 'Effective conversion click rate',
    goalConversion: 'Goal conversion',
    contribution: 'contribution',
    identity: 'Identity',
    time: 'Time',
    trendTitle: 'Trend summary',
    channelTitle: 'Channel Detail',
    siteTitle: 'Site traffic (source of previous page)',
    pageTitle: 'Page Detail',
    attributionType: 'Attribution Type',
    synchronization: 'Synchronization event',
    indexElement: 'Indicator elements',
    operator: 'operator',
    brackets: 'bracket',
    newsession: 'Create a Session',
    editsession: 'Edit the Session',
    sessionName: 'Session name',
    sessionEvent: 'The Session contains the events',
    cuttingRules: 'Cutting rules',
    sessionTip: 'Recommended cut time is 30 minutes for web products and 1 minute for APP products',
    globalfiltering: 'globalfiltering',
    numberOfViewers: 'Number of visitors',
    proportion: 'Proportion',
    funnyInformation: 'Funnel information',
    fullySettings: 'Funnel step settings'
  },
  group: {
    people: 'Number of people',
    newGroupRule: 'New group rule',
    editGroupRule: 'Edit group rule',
    setBase: 'Setting basic information',
    groupName: 'Group name',
    remark: 'Remark',
    configRule: 'Config group rule',
    behavior: 'Behavior',
    addFilter: 'Add filter',
    groupDetail: 'Grouped user details',
    unUpdated: 'Not up-to-date',
    do: 'Done',
    undo: 'Never done',
    dayNumber: 'Number of days',
    userBehavior: 'User behavior satisfaction',
    bebaviorSeq: 'Behavior sequence',
    or: 'Or',
    and: 'And',
    andFulfil: 'And fulfil',
    didItInTurn: 'Did it in turn',
    delBehavior: 'Delete behavior',
    delEvent: 'Delete event',
    delCondition: 'Delete condition',
    applicationName: 'Application Name',
    name: 'Name',
    platform: 'Platform',
    deviceVersion: 'Device version',
    networkType: 'The network type',
    operator: 'Operators',
    systemLanguage: 'System language',
    sourceChannel: 'Source channels(business_channel)',
    province: 'province',
    city: 'city',
    resolution: 'Screen resolution (height * width)',
    deviceBrand: 'Device brand',
    deviceModel: 'Device model',
    accessPath: 'Access path',
    pageParameter: 'Page parameters',
    eventParameter: 'Event parameters',
    page: 'Page',
    event: 'Event',
    at: 'At',
    beApplied: 'In the app',
    clickEvent: 'Click Events',
    browsePage: 'Browse the page'
  },
  channel: {
    name: 'Name',
    linkNumber: 'Number of links',
    activityName: 'Activity name',
    linkName: 'Link name',
    adSource: 'Campaign source',
    adMedia: 'Campaign medium',
    adContent: 'Campaign content',
    adName: 'Campaign name',
    adKey: 'Campaign keywords',
    channelKey: 'Channel ID',
    channelName: 'Channel name',
    bigChannel: 'Major channels',
    smallChannel: 'Small channel',
    putLink: 'Delivery link',
    landingPosi: 'Landing position',
    channelPosi: 'Channel location',
    channelDepartment: 'Channel department',
    remarkContent: 'Remark',
    rulePre: 'Rule prefix',
    ruleChannel: 'Rule channel',
    status: 'Status',
    articalTitle: 'Article title',
    link: 'Link',
    linkDetail: 'Link detail',
    promoteAttr: 'UTM promotion addr',
    trend: 'Trend',
    table: 'table',
    shortLink: 'Short chain with monitoring',
    clickNumber: 'Click volume',
    newActivity: 'New activity',
    editActivity: 'Edit activity',
    newLink: 'New link',
    editLink: 'Edit link',
    channel: 'Channel',
    newChannel: 'New channel',
    editChannel: 'Edit channel',
    channelRule: 'Channel rule',
    newChannelRule: 'New channel rule',
    editChannelRule: 'Edit channel rule',
    newShortChain: 'New short chain',
    editShortChain: 'Edit short chain',
    shortChain: 'shortChain',
    belongActivity: 'Activity',
    belongChannel: 'Channel',
    promoteAddr: 'Promote addr'
  },
  buriedPoint: {
    log: 'Log',
    groupName: 'Group name',
    containEvent: 'Include event',
    desc: 'Description',
    eventID: 'Event ID',
    attrId: 'Attr ID',
    attrName: 'Attr name',
    anotherName: 'Another Name',
    dataType: 'Data type',
    visible: 'Visibility',
    dataAttr: 'Data attr',
    group: 'Group',
    addEventGroup: 'New event group',
    editEventGroup: 'Edit event group',
    syncTime: 'Sync time',
    baseInformation: 'Basic information',
    eventDesc: 'Event desc',
    moveGroup: 'Move to group',
    moveReclaim: 'Move to recycle',
    customAttr: 'Custom attribute',
    index: 'Index',
    attrType: 'Attr type',
    attr: 'Attr',
    pageAttribute: 'Page Attribute',
    recentlyEdited: 'Editor',
    lastUpdateTime: 'Latest time',
    eventParam: 'Event param',
    recordTime: 'Record time',
    triggerRecord: 'Trigger record',
    addEvent: 'New event',
    editEvent: 'Edit event',
    virtualEvent: 'Composition of virtual events',
    belongAttr: 'Belong Attr',
    presetAttr: 'Preset attr',
    publicAttr: 'Public attr',
    sessionAttr: 'Session attr',
    pageAttr: 'Page attr',
    eventAttr: 'Event attr',
    userAttr: 'User attr',
    defaultAttr: 'Default attr',
    addAttr: 'Add attribute',
    editAttr: 'Edit attribute',
    addPageAttr: 'Add Page attribute',
    editPageAttr: 'Edit Page attribute',
    syncing: 'sync ing....',
    loading: 'loading....',
    selApp: 'Please select application:',
    exportEvents: 'Exporting Event List',
    attributesSize: 'Number of event attributes',
    synchronization: 'Synchronization event'
  },
  setting: {
    monitoringperiod: 'Monitoring period',
    projectName: 'Project name',
    projectType: 'Project type',
    projectStatus: 'Project status',
    projectLeader: 'Project leader',
    projectDeline: 'Project deadline',
    appName: 'App name',
    appPlatform: 'App platform',
    appUtc: 'App UTC',
    appStatus: 'App status',
    belongProject: 'Project',
    belongTenant: 'Tenant',
    name: 'Name',
    userName: 'Username',
    email: 'Email',
    belongRole: 'Role',
    roleName: 'Role name',
    roleCode: 'Role code',
    signKey: 'Sign Key',
    signSecret: 'Sign secret',
    desc: 'Desc',
    projectNumber: 'Number of authorized items',
    addRole: 'New role',
    roleDetail: 'Role detail',
    editRole: 'Edit role',
    menuPermission: 'Menu permission',
    organizationInformation: 'Organization information',
    addSign: 'New signature',
    editSign: 'Edit signature',
    sign: 'Signature',
    authorizeItem: 'Authorized item',
    generateKey: 'Generate Key',
    generateSecret: 'Generate Secret',
    selectProject: 'Please select project',
    authorized: 'Authorized',
    unauthorized: 'Unauthorized',
    phone: 'Phone',
    userMessage: 'User information',
    projectInformation: 'Project settings',
    personalProject: 'Personal project',
    loginRecord: 'Login record',
    displayInList: 'Whether to display in the top item list',
    loginTime: 'Login time',
    loginIp: 'Login IP',
    loginSource: 'Login source',
    changePassword: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    loginInformation: 'Login information',
    city: 'City',
    nickname: 'Nickname',
    age: 'Age',
    warning: 'Warning',
    addWarning: 'Create warning',
    editWarning: 'Edit warning',
    frequence: 'Frequency',
    threshold: 'Threshold',
    compareTo: 'Compare to',
    high: 'High',
    low: 'Low',
    percent: 'Percent',
    bookMember: 'Subscriber',
    bookEmail: 'Book email',
    creatAndUse: 'Create and Enable',
    warningManage: 'Warning manage',
    warningName: 'Warning name',
    heading: 'Name',
    everyDay: 'Every day',
    perHour: 'Per hour',
    open: 'Open',
    pvNumber: 'Views(PV)',
    uvNumber: 'Visitors(UV)',
    fixedValue: 'Fixed value',
    sameLastWeek: 'Same day last week',
    averageLastSeven: 'Average of seven days',
    lastHour: 'Last hour',
    inflowTime: 'The latest data inflow time',
    yesterdayHour: 'Same hour yesterday',
    functionType: 'Function type',
    operationType: 'Operation type',
    operationDate: 'Operation Date',
    operationUser: 'Operation user',
    operationBehavior: 'Specific operation behavior',
    roleAssign: 'Role assignment',
    fileStatus: 'Archive Status',
    from: 'from',
    noCollectData: 'No data collected to date'
  },
  menu: {
    addColumn: 'Add Column',
    name: 'Menu',
    enName: 'English Name',
    code: 'Code',
    route: 'Route',
    symbol: 'Symbol',
    order: 'Order',
    visible: 'Visible',
    addSub: 'Add Column',
    bindMenu: 'Attach To',
    upperMenu: 'Upper Menu',
    rootDirectory: 'Root Directory',
    type: 'Type',
    buttonName: 'Button Name',
    authorityName: 'Name',
    authorityCode: 'Code',
    authorityType: 'Type',
    button: 'Button',
    hasSelect: 'Selected',
    piece: '',
    pageButton: ' Page-Button Permission Management',
    addMenu: 'Add Menu',
    editMenu: 'Edit Menu'
  },
  system: {
    sortAttrAfter: 'Sort',
    moveUp: 'Up',
    moveDown: 'Down',
    password: 'Password',
    bindMenu: 'Binding menu',
    organizationName: 'Organization name',
    organizationAddr: 'Organization addr',
    organizationStatus: 'Organization status',
    menuName: 'Menu name',
    menuEnName: 'English name',
    menuCode: 'Menu code',
    menuPath: 'Menu path',
    filePath: 'File path',
    menuIcon: 'Menu icon',
    menuSort: 'Menu sort',
    userType: 'User type',
    lite: 'Mini program',
    organization: 'Organization',
    uvWord: 'UV statistical field',
    clickhouseRows: 'clickhouse Rows',
    sessionCutTime: 'session split time',
    cutTime: 'cut time',
    addSub: 'addSubdirectory',
    addMain: 'Add root directory',
    addApp: 'New app',
    editApp: 'Edit app',
    addProject: 'New project',
    editProject: 'Edit project',
    addUser: 'New user',
    editUser: 'Edit user',
    addOrganization: 'New organization',
    editOrganization: 'Edit organization',
    addMenu: 'New menu',
    editMenu: 'Edit menu',
    parentMenu: 'Upper menu',
    resetPassword: 'resetPassword',
    authorizeProject: 'authorizedItem',
    unbindMiniProgram: 'unbindApplet',
    open: 'Open',
    testProject: 'Test project',
    tenant: 'Tenant',
    multipleLogin: 'Multi-terminal login',
    organizationRole: 'Organization role',
    allow: 'Allow',
    notAllow: 'Not allow',
    tenantName: 'Tenant name',
    allSelect: 'Select all',
    reverseSelect: 'Reverse election',
    start: 'start up',
    end: 'block up',
    instanceName: 'Data Source Name',
    taskName: 'Task Name',
    instanceType: 'Type',
    tableName: 'Target Table',
    remark: 'remark',
    basicInformation: 'Basic Information',
    databaseConfig: 'Database Config',
    tenantAppSyn: 'Tenant-App data synchronization',
    tenantId: 'TenantId',
    tenantState: 'State',
    tenantApp: 'Tenant-App',
    addTenant_App: 'Add Tenant-App',
    state: 'State',
    bindApp: 'Syn App',
    bindFre: 'Syn Frequency',
    synTime: 'Last Syn time',
    addTenantApp: 'Add TenantConfig',
    addInstanceSource: 'Add Data Source',
    updateInstanceSource: 'Edit Data Source',
    addInstanceTask: 'New tasks',
    updateInstanceTask: 'Edit the task',
    mhInstanceSource: 'Data Source',
    sourceDetail: 'Data Source Detail',
    logType: 'Ali LogType',
    byDay: 'by day',
    byHour: 'by hour',
    byMonth: 'by month',
    task: 'task',
    taskList: 'Task List',
    inService: 'In Service',
    unService: 'Not Running',
    dashboard: 'System Dashboard',
    dataTrend: 'Data Trend',
    n7DataTop10: 'Last 7 days - Top10 in data',
    dataTop10: 'Data Top10',
    dataDashboard: 'Data Dashboard',
    ranking: 'Ranking',
    appName: 'AppName',
    dataSize: 'Data size',
    tenantCount: 'Tenant Count',
    proCount: 'Project Count',
    appCount: 'Application Count',
    activeAppCount: 'Number of active apps today',
    total: 'Total log rows',
    totalSize: 'Total log size',
    user: 'Total user rows',
    numberOfUsers: 'The number of user rows',
    numberOfLog: 'The number of log lines',
    userSize: 'Total user size',
    session: 'Total session rows',
    page: 'Total pageview rows',
    event: 'Total event rows',
    visible: 'Visible',
    mhInstanceTask: 'task'
  },
  form: {
    newOverviewWidth: '130px',
    newFunnelWidth: '140px',
    retainedWidth: '170px',
    userPathWidth: '220px',
    landingWidth: '150px',
    applicationWidth: '180px',
    attributionWidth: '220px',
    channelWidth: '180px',
    indicatorWidth: '160px',
    newLinkWidth: '160px',
    organizationWidth: '160px',
    projectQuerywidth: '100px',
    projectWidth: '130px',
    roleWidth: '130px',
    tenantWidth: '140px',
    signQueryWidth: '120px',
    eventQueryWidth: '110px',
    virtualQueryWidth: '110px',
    metaEventQueryWidth: '110px',
    promoteQueryWidth: '110px',
    shortChainWidth: '220px',
    tenantQueryWidth: '150px',
    addMhTenantAppFormLabelWidth: '120px',
    synSourceQueryWidth: '150px',
    overallAnalysis: '140px',
    eventAnalysis: '140px',
    funnelAnalysis: '160px',
    CreateSessionAnalysis: '240px',
    distributionAnalysis: '160px',
    sessionAnalysis: '160px',
    customIndicator: '160px',
    ltvAnalysis: '160px',
    personal: '150px',
    privilege: '113px',
    business_channel: '153px',
    user_form: '130px',
    business_channel_rule: '110px',
    page_attribute: '100px',
    meta_data_manage: '110px',
    event_group: '110px',
    meta_data: '120px',
    mh_instance_config: '150px',
    activity_manage: '120px',
    page: '140px',
    warning_form: '140px',
    changePassword_form: '150px',
    popover: '420px'
  }
}
